import { marginCSSVars } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import { useMemo } from 'react';

import type { TableProps } from './table.types';
import { TableBody } from './tableBody/tableBody';
import { TableCell } from './tableCell/tableCell';
import { TableFoot } from './tableFoot';
import { TableHead } from './tableHead';
import { TableHeaderCell } from './tableHeaderCell/tableHeaderCell';
import { TableRow } from './tableRow/tableRow';
import { TableSettingsContext } from './useTableSettings';

import styles from './table.module.css';

function BaseTable({
  children,
  className,
  'data-testid': testId,
  freezeLastColumn = false,
  freezeFirstColumn = false,
  minWidth = '100%',
  style,
  ...marginProps
}: TableProps) {
  const tableSettings = useMemo(
    () => ({
      freezeFirstColumn,
      freezeLastColumn,
    }),
    [freezeFirstColumn, freezeLastColumn]
  );
  return (
    <TableSettingsContext.Provider value={tableSettings}>
      <table
        className={clsx(className, styles['table'])}
        data-testid={testId}
        style={{
          ...marginCSSVars(marginProps),
          '--table-min-width': minWidth,
          ...style,
        }}
      >
        {children}
      </table>
    </TableSettingsContext.Provider>
  );
}

export const Table = Object.assign(BaseTable, {
  Body: TableBody,
  Cell: TableCell,
  Foot: TableFoot,
  Head: TableHead,
  HeaderCell: TableHeaderCell,
  Row: TableRow,
});
